<template>
    <modal-dialog
        ref="modal"
        label="Wat wil je opvolgen?"
        description="In dit scherm kun je kiezen wat voor soort flow je wilt opvolgen."
        :size="10"
        without-padding
    >
        <div class="template-info-modal">
            <div class="template-info-modal__header">
                <span>Wat wil je opvolgen?</span>
            </div>

            <div class="template-info-modal__list">
                <slot name="list" />
            </div>

            <div class="template-info-modal__container">
                <div class="template-info-modal__visual">
                    <slot name="visual" />
                </div>
                <div class="template-info-modal__content">
                    <slot name="content" />
                </div>
                <div class="template-info-modal__footer">
                    <slot name="footer" />
                </div>
            </div>
        </div>
    </modal-dialog>
</template>

<script setup lang="ts">
    import { ModalDialog, type ExposedOverlay } from '@keyvue/one-ui';
    import { ref } from 'vue';

    const modal = ref<ExposedOverlay>();
    defineExpose({
        openOverlay: () => {
            modal.value?.openOverlay();
        },
        closeOverlay: () => {
            modal.value?.closeOverlay();
        },
    });
</script>

<style scoped lang="scss">
.template-info-modal {
    display: grid;
    grid-template-rows: min-content auto;
    grid-template-columns: 40% 60%;
    height: 88vh;
    overflow: hidden;

    &__header {
        grid-column: span 2;
        font-weight: bold;
        font-size: size(md);
        padding: size(md);
        display: flex;
        justify-content: space-between;
    }

    &__list {
        background-color: color(gray-200);
        padding: size(md);
        overflow-y: scroll;
        display: grid;
        gap: size(sm);
        align-content: flex-start;
    }

    &__container {
        display: grid;
        grid-template-rows: 30vh auto max-content;
        overflow: hidden;
    }

    &__content {
        overflow-y: scroll;

        :deep(p:not(:last-child)) {
            margin-bottom: 1rem;
        }
    }

    &__footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: size(md);
        padding: size(md);
        border-top: 1px solid color(gray-200);
    }
}
</style>
